export const EmailFormMessages = {
  consentError: "Check the box to agree to our privacy policy.",
  emailError: "Check your email address and try again.",
  defaultError: "We encountered an error. Please try again.",
};
